'use strict';

angular
.module('far.maps.geocoder', [])
.provider('Geocoder', function() {
  return {
    setConfig: function(srcConfig) {
      angular.extend(config, srcConfig);
    },

    $get: function($q, uiGmapGoogleMapApi) {
      function Geocoder() {
        var geocoder, statusOk;

        uiGmapGoogleMapApi.then(function(maps) {
          geocoder = new maps.Geocoder;
          statusOk = maps.GeocoderStatus.OK;
        });

        this.geocode = function(locationObj, callback) {
          return $q(function(resolve, reject) {
            if (!geocoder) {
              return reject('Maps not initialized');
            }

            geocoder.geocode(locationObj, function(results, status) {
              if (status == statusOk) {
                resolve({
                  result: results,
                  status: status
                });
              } else {
                reject({
                  result: results,
                  status: status
                });
              }

              if (angular.isFunction(callback)) {
                callback(results, status);
              }
            });
          });
        }

        this.getLocationsByAddress = function(address, callback) {
          return this.geocode({
            address: address
          }, callback);
        }

        this.getLocationsByLocation = function(location, callback) {
          return this.geocode({
            location: location
          }, callback);
        }

        this.getLocationsByPlaceId = function(placeId, callback) {
          return this.geocode({
            placeId: placeId
          }, callback);
        }

        this.getLatLngObject = function(location) {
          return {
            latitude: location.lat(),
            longitude: location.lng()
          }
        }
      }

      return Geocoder;
    }
  };
});
